type StateEraserIconProps = {
  size?: number
}

export function StateEraserIcon({ size = 24 }: StateEraserIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2ZM12 10.8574L8.14258 7L7 8.14258L10.8574 12L7 15.8574L8.14258 17L12 13.1426L15.8574 17L17 15.8574L13.1426 12L17 8.14258L15.8574 7L12 10.8574Z"
        fill="currentColor"
      />
    </svg>
  )
}
